import type { Testimonial } from "../types/offer";

/** BORRADOR: testimonios de ejemplo. Reemplazar por reseñas reales antes de publicar. */
export const testimonials: Testimonial[] = [
  {
    name: "Lucía y Martín",
    business: "Pastelería por encargo",
    photo: "https://cdn.magicpatterns.com/uploads/j2QpGBXSCN1AAtzyYFFYdP/img_cns_2.jpg",
    quote:
      "Hacemos tortas por encargo y en las fotos nunca se veía el relleno. Con la parte de comida aprendimos a usar el ángulo de 45° y la luz de la ventana. Ahora las fotos se parecen a lo que entregamos.",
  },
  {
    name: "Tomás R.",
    business: "Accesorios para celular",
    photo: "https://cdn.magicpatterns.com/uploads/wwMeU4GLSETT4mFJNGdhLB/img_cns_3.jpg",
    quote:
      "Grababa todo en automático y los videos salían oscuros. Entender exposición y enfoque me cambió el contenido. El bono del catálogo me ordenó las fotos para mandar por WhatsApp.",
  },
  {
    name: "Jorge M.",
    business: "Taller de carpintería",
    photo: "https://cdn.magicpatterns.com/uploads/mMorZV5aZymc6CNsozdS6Y/img_cns_4.jpg",
    quote:
      "No me llevo bien con la tecnología, pero la guía va paso a paso. Armé el miniestudio con una mesa y una cartulina, y por fin se ven las terminaciones de los muebles.",
  },
];
